import { component as defineComponent } from 'flightjs';

function workedTogetherIcon() {
    this.after('initialize', function() {
        this.on(document, 'dataClientsLoaded', this.setIcon);
    });

    this.setIcon = function(e, data) {
        if (data.workedTogetherClientIds.includes(this.clientId())) {
            this.$node.removeAttr('data-hidden');
        }
    };

    this.clientId = function() {
        return this.$node.data('clientId');
    };
}

export default defineComponent(workedTogetherIcon);



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/worked-together.js